module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/8a00ace5bd2b03863eac877c6d2ffe47.svg";